<template>
  <v-container class="pa-0 asc-user-dialog-container">
    <v-form class="asc-user-dialog-form">
      <v-row>
        <v-col cols="3">
          <asc-text-field-input
            v-model="newUserDetails.fields.firstName"
            label="First Name"
            placeholder="Placeholder"
            required
            :rules="newUserDetails.rules.firstName"
            :disabled="isUserReader"
          />
        </v-col>
        <v-col cols="3">
          <asc-text-field-input
            v-model="newUserDetails.fields.lastName"
            label="Last Name"
            placeholder="Placeholder"
            :rules="newUserDetails.rules.lastName"
            required
            :disabled="isUserReader"
          />
        </v-col>
        <v-col cols="3">
          <asc-text-field-input
            v-model="newUserDetails.fields.userName"
            label="Username"
            placeholder="username@domain.com"
            required
            :rules="newUserDetails.rules.userName"
            :disabled="isUserReader"
          />
        </v-col>
        <v-col cols="3">
          <asc-text-field-input
            v-model="newUserDetails.fields.userEmail"
            label="Email"
            placeholder="Placeholder"
            required
            :rules="newUserDetails.rules.userEmail"
            :disabled="isUserReader"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="addNewCompany" cols="3">
          <div class="asc-user-dialog-form-row2--company">
            <asc-text-field-input
              v-model="company"
              label="Company"
              placeholder="Add New Company"
              required
              :disabled="isUserReader"
            />
            <asc-tooltip top tooltip="Revert to Company List">
              <v-btn text @click="revertToDropdown">
                <asc-close-icon></asc-close-icon>
              </v-btn>
            </asc-tooltip>
          </div>
        </v-col>
        <v-col v-else cols="3">
          <asc-autocomplete-selector
            v-model="company"
            label="Company"
            :items="companyOptions"
            dense
            short
            required
            :rules="newUserDetails.rules.company"
            fixed-position
            :disabled="isUserReader"
          />
        </v-col>
        <v-col cols="3">
          <asc-autocomplete-selector
            v-model="country"
            label="Country"
            :items="countriesOptions"
            dense
            short
            required
            fixed-position
            use-strings
            :disabled="isUserReader"
          />
        </v-col>
        <v-col class="d-flex align-center flex-column">
          <asc-label value="US Person" :color="color" />
          <v-checkbox
            v-model="newUserDetails.fields.isUSPerson"
            :value="newUserDetails.fields.isUSPerson"
            :disabled="isUserReader"
            :ripple="false"
            :true-value="true"
            :false-value="false"
            class="asc-checkbox"
          />
        </v-col>
        <v-col class="d-flex align-center flex-column">
          <asc-label value="Active" :color="color" />
          <v-checkbox
            v-model="newUserDetails.fields.isActive"
            :value="newUserDetails.fields.isActive"
            :disabled="isUserReader"
            :ripple="false"
            :true-value="true"
            :false-value="false"
            class="asc-checkbox"
          />
        </v-col>
        <v-col class="d-flex align-center flex-column">
          <asc-label value="Internal" :color="color" />
          <v-checkbox
            v-model="newUserDetails.fields.isCollinsInternal"
            :value="newUserDetails.fields.isCollinsInternal"
            :disabled="isUserReader"
            :ripple="false"
            :true-value="true"
            :false-value="false"
            class="asc-checkbox"
          />
        </v-col>
        <v-col v-if="!edit" class="d-flex align-center flex-column">
          <asc-label value="Federated" :color="color" />
          <v-checkbox
            v-model="newUserDetails.fields.isFederated"
            :value="newUserDetails.fields.isFederated"
            :disabled="isUserReader"
            :ripple="false"
            :true-value="true"
            :false-value="false"
            class="asc-checkbox"
          />
        </v-col>
        <v-col v-if="!edit" class="d-flex align-center flex-column">
          <asc-label value="Invitation" :color="color" />
          <v-checkbox
            v-model="nnewUserDetails.fields.sendInvite"
            :value="newUserDetails.fields.sendInvite"
            :disabled="isUserReader"
            :ripple="false"
            :true-value="true"
            :false-value="false"
            class="asc-checkbox"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <asc-autocomplete-selector
            v-model="newUserDetails.fields.airlineIds"
            class="asc-user-dialog-form-row3--dropdown-row3"
            label="Airlines"
            :items="airlinesOptions"
            component-type="multiple"
            display-clear
            dense
            short
            required
            fixed-position
          />
        </v-col>
        <v-col cols="3">
          <asc-autocomplete-selector
            v-model="newUserDetails.fields.acmfReportTypeIds"
            class="asc-user-dialog-form-row3--dropdown-row3"
            label="Report Types"
            :items="reportsOptions"
            component-type="multiple"
            display-clear
            dense
            short
            fixed-position
          />
        </v-col>
        <v-col cols="3">
          <asc-autocomplete-selector
            v-model="newUserDetails.fields.roleIds"
            class="asc-user-dialog-form-row3--dropdown-row3"
            label="Legacy Roles"
            :items="roleOptions"
            component-type="multiple"
            display-clear
            dense
            short
            required
            fixed-position
          />
        </v-col>
        <v-col cols="3">
          <asc-autocomplete-selector
            v-model="newUserDetails.fields.groupIds"
            class="asc-user-dialog-form-row3--dropdown-row3"
            label="Roles"
            :items="groupOptions"
            component-type="multiple"
            display-clear
            dense
            short
            required
            fixed-position
          />
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import AscCloseIcon from '@/components/atoms/AscCloseIcon'
import AscLabel from '@/components/atoms/AscLabel'
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'
import AscTooltip from '@/components/atoms/AscTooltip'
import variables from '@/styles/_varsJs.scss'
import { COUNTRIES } from '@/utilities/appConsts'
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import AscAutocompleteSelector from './AscAutocompleteSelector'

export default {
  name: 'AscUserDialogForm',

  components: {
    AscAutocompleteSelector,
    AscTextFieldInput,
    AscLabel,
    AscCloseIcon,
    AscTooltip,
  },

  props: {
    color: {
      type: String,
      default: variables.gray700,
    },
    airlines: {
      type: Array,
      default: () => [],
    },
    role: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
    companies: {
      type: Array,
      default: () => [],
    },
    reportTypes: {
      type: Array,
      default: () => [],
    },
    user: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Boolean,
      default: false,
    },
    isUserReader: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      newUserDetails: {
        fields: {
          firstName: '',
          lastName: '',
          userName: '',
          userEmail: '',
          companyId: '',
          country: '',
          identityId: '',
          isActive: false,
          isCollinsInternal: false,
          isFederated: false,
          sendInvite: false,
          airlineIds: [],
          roleIds: [],
          acmfReportTypeIds: [],
          isUSPerson: false,
          groupIds: [],
        },
        rules: {
          firstName: [v => !!v || 'First name is required'],
          lastName: [v => !!v || 'Last name is required'],
          userName: [v => !!v || 'User name is required'],
          userEmail: [v => !!v || 'Email is required'],
          company: [v => !!v || 'Company is required'],
        },
      },
      addNewCompany: false,
    }
  },

  computed: {
    country: {
      get() {
        return this.newUserDetails.fields.country
      },
      set(val) {
        this.newUserDetails.fields.country = val[0] ? val[0] : null
      },
    },
    company: {
      get() {
        return this.newUserDetails.fields.companyId
      },
      set(val) {
        if (this.addNewCompany) {
          this.newUserDetails.fields.companyId = val
        } else {
          const isInCompanyList = this.companies.filter(
            item => item.id === val[0],
          )
          if (val && isInCompanyList.length === 0) {
            this.addNewCompany = true
            this.newUserDetails.fields.companyId = ''
          } else {
            this.newUserDetails.fields.companyId = val[0]
          }
        }
      },
    },
    groupOptions() {
      if (this.groups) {
        return this.groups.map(item => ({
          text: item.name,
          value: item.id,
        }))
      }
      return []
    },

    roleOptions() {
      if (this.role) {
        return this.role.map(item => ({
          text: item.name,
          value: item.id,
        }))
      }
      return []
    },
    airlinesOptions() {
      if (this.airlines) {
        return this.airlines.map(item => ({
          text: item.name,
          value: item.id,
        }))
      }
      return []
    },
    countriesOptions() {
      if (COUNTRIES) {
        return COUNTRIES.map(item => ({
          text: item,
          value: item,
        }))
      }
      return []
    },
    companyOptions() {
      if (this.companies) {
        const companyList = this.companies.map(item => ({
          text: item.name,
          value: item.id,
        }))
        companyList.push({
          text: '---Add New---',
          value: uuidv4(),
        })
        return companyList
      }
      return []
    },
    reportsOptions() {
      if (this.reportTypes) {
        return this.reportTypes.map(item => ({
          text: item.displayName,
          value: item.id,
        }))
      }
      return []
    },
  },

  watch: {
    newUserDetails: {
      deep: true,
      handler() {
        this.$emit('input', _.omit(this.newUserDetails, ['rules']))
      },
    },
    user: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.newUserDetails.fields = { ...newValue }
        }
      },
    },
  },

  methods: {
    revertToDropdown() {
      this.addNewCompany = false
      this.newUserDetails.fields.companyId = ''
    },
  },
}
</script>

<style lang="scss">
.asc-user-dialog-container {
  .asc-autocomplete-selector {
    width: 100%;
  }

  .asc-checkbox.v-input--checkbox {
    .v-input--selection-controls__input {
      width: 18px;
      height: 18px;
      margin: 0;

      .v-icon {
        width: 18px;
        height: 18px;
        border-radius: 2px;
        font-size: 21px;
      }
    }
    .v-icon.mdi-checkbox-marked.theme--light {
      background-color: $primary-black;
      border: 2px solid $accent-400;
      color: $accent-500;
    }
  }
}
</style>
